export default {
    功能管理: '功能管理'
}
